import { Component, inject, input, OnInit, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MbmAlertComponent } from '@components';
import { MBM_MODAL_PROVIDERS } from './mbm-modal-providers';
import { MbmModalMessageService } from './mbm-modal-message.service';
import { MbmModalService } from './mbm-modal.service';

/** Bottom sheet on phones, centered dialog on tablets (styling in styles.scss + here). */
@Component({
  selector: 'mbm-modal',
  templateUrl: './mbm-modal.component.html',
  styleUrl: './mbm-modal.component.scss',
  imports: [TranslateModule, MbmAlertComponent],
  providers: [...MBM_MODAL_PROVIDERS],
})
export class MbmModalComponent implements OnInit {
  private readonly messageService = inject(MbmModalMessageService);
  private readonly modalService = inject(MbmModalService);

  readonly titleKey = input<string>('');
  readonly title = input<string | undefined>(undefined);
  readonly showCloseButton = input<boolean>(true);
  readonly modalClose = output<void>();
  readonly modalInit = output<MbmModalService>();

  protected readonly errorMessages = this.messageService.errorMessages;
  protected readonly successMessages = this.messageService.successMessages;

  ngOnInit(): void {
    this.modalInit.emit(this.modalService);
  }
}
